import {
  GouvGeorisquesDto,
  GouvGeorisquesRisqueDto,
  PropertyDto,
  PropertyRoomType,
} from '@workspace/data-types';
import { EtxeEnumsNiceLabelUtils } from '../../utils/etxe-enums-nice-label.utils';
import { getPropertyEquipmentInfo } from '../components/property-characteristics/equipments-list/property-equipment.constants';
import { OsmPoi } from './osm-poi.utils';

export interface PropertyPrintOptions {
  mode: 'detailed' | 'summary';
  includeContactInfos: boolean;
  includeExactAddress: boolean;
  includeMapAndPois?: boolean;
  includeGeospatial?: boolean;
  sellerName?: string | null;
  sellerPhone?: string | null;
  sellerEmail?: string | null;
  pois?: OsmPoi[];
  staticMapUrl?: string | null;
  geohazard?: GouvGeorisquesDto | null;
}

export interface PrintableRiskItem {
  key: string;
  libelle: string;
  present: boolean;
  precision?: string | null;
}

const DPE_COLORS: Record<string, string> = {
  A: '#00803C',
  B: '#54B345',
  C: '#CED932',
  D: '#FFF200',
  E: '#FCBA08',
  F: '#EB8235',
  G: '#D71D20',
};

const GES_COLORS: Record<string, string> = {
  A: '#8BD1E8',
  B: '#74BBD6',
  C: '#5DA5C4',
  D: '#468FB2',
  E: '#2F79A0',
  F: '#18638E',
  G: '#004D7C',
};

const ETXE_LOGO_SVG = `<svg class="brand-svg" viewBox="0 0 1000 1000" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd" aria-hidden="true"><path fill="#A62C23" d="M39.75,494.13c-7.92-11.69-14.91-21.99-23.38-34.49c20.17-13.07,39.25-25.45,58.35-37.8c130.54-84.41,261.16-168.71,391.48-253.47c8.75-5.69,14.38-5.4,22.86,0.09c143.98,93.33,288.12,186.42,432.46,279.2c13.02,8.37,16.49,15.84,4.81,27.83c-4.68,4.81-7.73,11.21-12.56,18.44c-27.12-17.36-53.75-34.2-80.18-51.35C721.06,369.58,608.46,296.7,496.3,223.12c-13.84-9.08-23.72-9.71-38.07-0.29C331.66,305.93,204.53,388.17,77.52,470.6C65.54,478.37,53.29,485.71,39.75,494.13z"/><path fill="#A62C23" d="M367.93,807.7c69.14,0,135.19,0,202.48,0c0,14.58,0,27.53,0,41.95c-78.87,0-156.89,0-236.76,0c-0.29-6.23-0.81-12.34-0.82-18.45c-0.12-74.38-0.23-148.75-0.18-223.13c0.02-31.67,0.19-31.67,35.17-28.87c0,15.83,0,31.98,0,52.25c10.02-8.45,16.38-13.81,24.25-20.44c7.02,7.35,13.58,14.21,21.89,22.91c-11.33,11.56-21.62,22.92-32.83,33.27c-10.61,9.8-14.16,21.13-13.84,35.42c0.31,13.68,6.09,15.24,17.4,12.58c56.99-13.39,79.18-77.94,39.75-121.38c-14.25-15.69-21.72-29.37-19.33-51.04c2.7-24.56-10.69-43.39-32.47-54.55c-16.45-8.43-33.74-7.13-49.46,2.84c-22.88,14.5-31.64,36.17-27.86,62.38c1.9,13.14-0.79,21.7-11.26,31.23c-42.44,38.67-35.43,95.62,14.84,123.41c17.99,9.95,5.61,24.36,9.54,36.53c-43.04-2.12-84.26-49.95-86.07-98.12c-1-26.62,6.74-50.7,24.65-69.86c11.25-12.04,14.33-24.27,14.92-40.05c1.45-38.85,21.92-66.32,57.42-81.19c31.63-13.25,61.26-6.49,87,15.34c21.71,18.41,32.55,42.12,33.64,71.11c0.39,10.49,4.44,22.6,10.85,30.83c55.47,71.23,20.93,161.47-68.68,176.36c-12.19,2.03-15.08,6.77-14.41,17.83C368.54,779.91,367.93,793.03,367.93,807.7z"/><path fill="#1E5E36" d="M631.52,759.55c0,15.64,0,30.88,0,48.24c97.72,0,194.23,0,289.34,0c1.66,2.6,2.16,3.04,2.23,3.54c5.46,39.47,5.45,39.47-33.41,39.48c-89.88,0.01-179.76,0.03-269.64,0.05c-7.36,0-14.73,0-24.73,0c0-26.21-0.52-50.79,0.23-75.33c0.35-11.51-2.69-16.71-14.81-20.02c-63.77-17.42-86.12-87.07-46.32-140.29c4.7-6.29,7.63-15.34,7.94-23.24c1.49-38.52,31.18-69.14,69.27-70.05c38.23-0.92,70.47,29.88,72.87,68.52c0.54,8.62,2.44,18.6,7.36,25.27c41.18,55.98,14.81,127.06-53.3,142.01C636.37,758.21,634.23,758.84,631.52,759.55z M630.98,724.3c21.97-1.94,35.71-13.11,43.07-29.94c9.15-20.94,7.51-42.83-9.7-59.25c-11.59-11.06-15.59-21.78-14.11-37.58c2.06-22.05-10.03-37.84-28.12-41.55c-26.57-5.45-48.44,12.12-47.12,40.26c0.74,15.86-1.16,27.48-13.98,39.1c-16.68,15.12-18.65,43.36-6.54,62.44c8.83,13.91,20.62,25.32,41.86,25.59c0-22.92,0-43.91,0-64.62c12.5,0,22.57,0,34.64,0C630.98,680.99,630.98,701.98,630.98,724.3z"/><path fill="#1E5E36" d="M129.44,849.45c-0.36-4.98-0.97-9.45-0.97-13.93c-0.06-111.85,0.07-223.69-0.26-335.54c-0.03-10.82,2.85-17.59,12.48-23.73c109.77-69.93,219.21-140.38,328.77-210.63c1.83-1.17,4.1-1.66,6.85-2.73c6.83,11.05,13.44,21.74,21.05,34.05c-27.28,17.71-54.09,35.32-81.09,52.62c-79.05,50.64-158.24,101.05-237.09,152.01c-4.43,2.86-8.83,9.79-8.85,14.85c-0.45,94.55-0.24,189.1-0.1,283.65c0,1.64,0.78,3.28,1.75,7.05c44.25,0,88.85,0,134.86,0c0,15.04,0,27.95,0,42.35C248.63,849.45,190.13,849.45,129.44,849.45z"/></svg>`;

export class PropertyPdfPrintUtils {
  static formatPrice(cents?: number | null): string {
    if (cents == null || cents <= 0) return 'Prix sur demande';
    return `${Math.round(cents / 100).toLocaleString('fr-FR')} €`;
  }

  static getWalkMinutes(meters?: number): number {
    if (!meters) return 1;
    return Math.max(1, Math.round(meters / 80));
  }

  static countMainRooms(property: PropertyDto): number | null {
    const interior = property.characteristics?.interior;
    if (!interior) return null;

    const eligibleTypes = new Set<PropertyRoomType>([
      PropertyRoomType.LIVING_ROOM,
      PropertyRoomType.DINING_ROOM,
      PropertyRoomType.OFFICE,
      PropertyRoomType.LIBRARY,
      PropertyRoomType.PLAYROOM,
      PropertyRoomType.MUSIC_STUDIO,
    ]);

    let count = 0;
    if (Array.isArray(interior.bedroom)) {
      for (const b of interior.bedroom) {
        const s = Number(b.surface);
        if (Number.isNaN(s) || s >= 9) count++;
      }
    }
    if (Array.isArray(interior.rooms)) {
      for (const r of interior.rooms) {
        if (r.type && eligibleTypes.has(r.type)) {
          const s = Number(r.surface);
          if (Number.isNaN(s) || s >= 9) count++;
        }
      }
    }
    return count > 0 ? count : null;
  }

  static extractGeohazardRisks(geohazard?: GouvGeorisquesDto | null): {
    naturalRisks: PrintableRiskItem[];
    technoRisks: PrintableRiskItem[];
    detectedCount: number;
    url?: string;
  } {
    if (!geohazard) {
      return { naturalRisks: [], technoRisks: [], detectedCount: 0 };
    }

    const rn = geohazard.risquesNaturels;
    const naturalDefs: { key: string; label: string; risk?: GouvGeorisquesRisqueDto }[] = rn
      ? [
          { key: 'inondation', label: 'Inondation & submersion marine', risk: rn.inondation },
          {
            key: 'retraitGonflementArgile',
            label: 'Retrait-gonflement des argiles (RGA)',
            risk: rn.retraitGonflementArgile,
          },
          { key: 'seisme', label: 'Zone de sismicité', risk: rn.seisme },
          { key: 'feuForet', label: 'Feux de forêt', risk: rn.feuForet },
          { key: 'radon', label: 'Potentiel radon', risk: rn.radon },
          { key: 'mouvementTerrain', label: 'Mouvements de terrain', risk: rn.mouvementTerrain },
          { key: 'remonteeNappe', label: 'Remontée de nappe phréatique', risk: rn.remonteeNappe },
          { key: 'avalanche', label: 'Risque avalanche', risk: rn.avalanche },
        ]
      : [];

    const naturalRisks: PrintableRiskItem[] = naturalDefs.map((item) => ({
      key: item.key,
      libelle: item.label,
      present: Boolean(item.risk?.present),
      precision:
        item.risk?.libelleStatutAdresse || item.risk?.specifique || item.risk?.libelleStatutCommune || null,
    }));

    const rt = geohazard.risquesTechnologiques;
    const technoDefs: { key: string; label: string; risk?: GouvGeorisquesRisqueDto }[] = rt
      ? [
          { key: 'icpe', label: 'Installations industrielles (ICPE)', risk: rt.icpe },
          { key: 'nucleaire', label: 'Installations nucléaires', risk: rt.nucleaire },
          { key: 'pollutionSols', label: 'Pollution des sols (BASIAS / BASOL)', risk: rt.pollutionSols },
          {
            key: 'canalisationsMatieresDangereuses',
            label: 'Canalisations de matières dangereuses',
            risk: rt.canalisationsMatieresDangereuses,
          },
          { key: 'ruptureBarrage', label: 'Rupture de barrage', risk: rt.ruptureBarrage },
          { key: 'risqueMinier', label: 'Risques miniers', risk: rt.risqueMinier },
        ]
      : [];

    const technoRisks: PrintableRiskItem[] = technoDefs.map((item) => ({
      key: item.key,
      libelle: item.label,
      present: Boolean(item.risk?.present),
      precision:
        item.risk?.libelleStatutAdresse || item.risk?.specifique || item.risk?.libelleStatutCommune || null,
    }));

    const detectedCount =
      naturalRisks.filter((r) => r.present).length + technoRisks.filter((r) => r.present).length;

    return {
      naturalRisks,
      technoRisks,
      detectedCount,
      url: geohazard.url,
    };
  }

  static generatePrintHtml(property: PropertyDto, options: PropertyPrintOptions): string {
    const isDetailed = options.mode === 'detailed';
    const today = new Date().toLocaleDateString('fr-FR', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    });
    const propertyReference =
      property.definition?.reference?.trim() ||
      (property._id ? `#${property._id.toString().slice(-6).toUpperCase()}` : 'ANNONCE');

    const title = property.presentation?.title || 'Fiche descriptive du bien';
    const priceStr = this.formatPrice(property.financials?.sellingPriceCents);
    const priceCents = property.financials?.sellingPriceCents;
    const surfaceHab = property.keyInfo?.surface?.habitable;
    const pricePerM2 =
      priceCents && surfaceHab && surfaceHab > 0
        ? `${Math.round(priceCents / 100 / surfaceHab).toLocaleString('fr-FR')} €/m²`
        : null;

    const propertyTypeStr = property.definition?.propertyType
      ? EtxeEnumsNiceLabelUtils.propertyType(property.definition.propertyType)
      : 'Bien immobilier';
    const subtypeStr = property.keyInfo?.subtype
      ? EtxeEnumsNiceLabelUtils.propertySubtype(property.keyInfo.subtype, property.definition?.propertyType)
      : null;

    const city = property.location?.address?.city || '';
    const zipCode = property.location?.address?.zipCode || '';
    const street = options.includeExactAddress ? property.location?.address?.street || '' : '';
    const addressStr = [street, zipCode, city].filter(Boolean).join(', ');

    const surfaceLand = property.keyInfo?.surface?.land || property.geospatial?.cadastral?.totalSurface;
    const surfaceGround = property.keyInfo?.surface?.ground;
    const availability = property.keyInfo?.availability;
    const mandate = property.mandate;
    const mandatePriorities = (mandate?.priorities || []).map((p) =>
      EtxeEnumsNiceLabelUtils.sellerPriority(p),
    );
    const mandateKeyManagement = (mandate?.keyManagement || []).map((k) =>
      EtxeEnumsNiceLabelUtils.keyManagement(k),
    );
    const equipmentItems = (property.characteristics?.equipments?.items || []).map((e) =>
      getPropertyEquipmentInfo(e),
    );

    const roomCount = this.countMainRooms(property);
    const bedroomCount = (property.characteristics?.interior?.bedroom || []).length;
    const bathroomCount =
      (property.characteristics?.interior?.bathroom || []).length +
      (property.characteristics?.interior?.showerRoom || []).length;
    const wcCount = property.characteristics?.interior?.wc;
    const year =
      property.construction?.precision ||
      (property.construction?.year
        ? EtxeEnumsNiceLabelUtils.constructionPeriod(property.construction.year)
        : null);
    const parkings = (property.characteristics?.parkings || []).reduce((acc, p) => acc + (p.count || 1), 0);

    const photos = property.media?.photos || [];
    const mainPhotoUrl = photos[0]?.url || '';
    const secondaryPhotos = photos.slice(1, isDetailed ? 5 : 4).filter((p) => Boolean(p.url));

    const description = property.presentation?.description || '';

    // DPE / GES
    const dpeClass = property.dpe?.energyClass?.toUpperCase();
    const dpeConsumption = property.dpe?.energyConsumption;
    const gesClass = property.dpe?.climateClass?.toUpperCase();
    const gesEmissions = property.dpe?.greenhouseGasEmission;
    const dpeDate = property.dpe?.realizationDate
      ? new Date(property.dpe.realizationDate).toLocaleDateString('fr-FR')
      : null;
    const dpeAdeme = property.dpe?.ademeNumber || null;
    const dpeCostMin = property.dpe?.estimatedCostMin;
    const dpeCostMax = property.dpe?.estimatedCostMax;

    // Contact details
    const sellerName = options.sellerName || 'Propriétaire vendeur';
    const sellerPhone = options.sellerPhone || null;
    const sellerEmail = options.sellerEmail || null;

    // Financials & Taxes & Copro
    const propertyTax = property.financials?.taxesAndFees?.propertyTaxCents
      ? `${Math.round(property.financials.taxesAndFees.propertyTaxCents / 100).toLocaleString('fr-FR')} €/an`
      : null;
    const coOwnershipCharges = property.financials?.coOwnershipChargesCents
      ? `${Math.round(property.financials.coOwnershipChargesCents / 100).toLocaleString('fr-FR')} €/mois`
      : null;

    // Detailed Rooms (for detailed mode)
    const interior = property.characteristics?.interior;
    const detailedRoomsList: Array<{ name: string; surface?: number; precision?: string }> = [];
    if (interior?.bedroom) {
      interior.bedroom.forEach((b, idx) => {
        detailedRoomsList.push({
          name: `Chambre ${idx + 1}`,
          surface: b.surface,
          precision: b.precision,
        });
      });
    }
    if (interior?.rooms) {
      interior.rooms.forEach((r) => {
        detailedRoomsList.push({
          name: r.type ? EtxeEnumsNiceLabelUtils.room(r.type) : 'Pièce',
          surface: r.surface,
          precision: r.precision,
        });
      });
    }
    if (interior?.bathroom) {
      interior.bathroom.forEach((_, idx) => {
        detailedRoomsList.push({ name: `Salle de bain ${idx + 1}` });
      });
    }
    if (interior?.showerRoom) {
      interior.showerRoom.forEach((_, idx) => {
        detailedRoomsList.push({ name: `Salle d'eau ${idx + 1}` });
      });
    }

    // Construction & Technical details
    const construction = property.construction;
    const heatingType = property.dpe?.technical?.heatingType || null;
    const heatingEnergy = property.dpe?.technical?.heatingEnergy || null;
    const hasAirConditioning = property.dpe?.technical?.hasAirConditioning ?? null;
    const ventilationType = property.dpe?.technical?.ventilationType || null;
    const glazing = construction?.insulation?.glazing || property.dpe?.technical?.glazingQuality || null;
    const wallsMaterial = construction?.material?.walls?.length
      ? construction.material.walls.map((m) => EtxeEnumsNiceLabelUtils.constructionMaterial(m)).join(', ')
      : null;
    const roofMaterial = construction?.material?.roof?.length
      ? construction.material.roof.map((r) => EtxeEnumsNiceLabelUtils.roofMaterial(r)).join(', ')
      : null;
    const condition = construction?.conditions?.interior
      ? EtxeEnumsNiceLabelUtils.condition(construction.conditions.interior)
      : null;

    // Accessibility & Co-ownership details
    const keyInfo = property.keyInfo;
    const accessibility = keyInfo?.accessibility;
    const apartmentFloor = accessibility?.apartment?.floor;
    const buildingNumberOfFloors = accessibility?.buildingNumberOfFloors;
    const hasElevator = accessibility?.hasElevator ?? accessibility?.buildingHasElevator;
    const pmrCompliance = accessibility?.pmrCompliance;

    const coOwnership = keyInfo?.coOwnership;
    const isInCoOwnership = coOwnership?.isInCoOwnership;
    const numberOfLots = coOwnership?.numberOfLots;
    const lotNumber = coOwnership?.lotNumber;
    const trusteeName = coOwnership?.trustee?.name;

    // Exterior details
    const exterior = property.characteristics?.exterior;
    const gardenSurface = (exterior?.garden || []).reduce((acc, g) => acc + (g.surface || 0), 0);
    const terraceSurface = (exterior?.terrace || []).reduce((acc, t) => acc + (t.surface || 0), 0);
    const balconySurface = (exterior?.balcony || []).reduce((acc, b) => acc + (b.surface || 0), 0);
    const hasPool = (exterior?.swimmingPool || []).length > 0;
    const orientation = construction?.orientation?.length
      ? construction.orientation.map((o) => EtxeEnumsNiceLabelUtils.orientation(o)).join(', ')
      : null;

    // Cadastral data
    const cadastral = property.geospatial?.cadastral;
    const primaryParcel = cadastral?.parcels?.[0];
    const totalCadastralSurface = cadastral?.totalSurface || surfaceLand;
    const groundFootprint = construction?.groundFootprint;

    // Environmental, Sitadel & Geospatial
    const noise = property.geospatial?.noise;
    const insee = property.geospatial?.insee;
    const sitadel = property.geospatial?.sitadel;
    const geohazard = options.geohazard ?? property.geospatial?.geohazard;
    const geohazardData = this.extractGeohazardRisks(geohazard);

    // POIs list & Map
    const pois = options.pois?.slice(0, 8) || [];
    const staticMapUrl = options.staticMapUrl || null;

    // Build DPE spectrum HTML
    const renderSpectrum = (activeGrade?: string, isGhg = false) => {
      const grades = ['A', 'B', 'C', 'D', 'E', 'F', 'G'];
      const colors = isGhg ? GES_COLORS : DPE_COLORS;
      return `
        <div style="display:flex;gap:4px;align-items:center;">
          ${grades
            .map((g) => {
              const isActive = activeGrade === g;
              const bgColor = isActive ? colors[g] : '#f1f5f9';
              const textColor = isActive ? '#ffffff' : '#64748b';
              const scale = isActive
                ? 'font-weight:bold;transform:scale(1.15);box-shadow:0 1px 3px rgba(0,0,0,0.2);'
                : 'font-weight:500;';
              return `<div style="flex:1;text-align:center;padding:5px 0;background-color:${bgColor};color:${textColor};border-radius:4px;font-size:11px;${scale}">${g}</div>`;
            })
            .join('')}
        </div>
      `;
    };

    return `<!DOCTYPE html>
<html lang="fr">
<head>
  <meta charset="utf-8">
  <title>Détails du bien ${propertyReference} _ ETXE</title>
  <style>
    @page {
      size: A4 portrait;
      margin: 10mm 12mm;
    }
    * {
      box-sizing: border-box;
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }
    body {
      font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
      margin: 0;
      padding: 0;
      background: #ffffff;
      color: #0f172a;
      font-size: 11.5px;
      line-height: 1.45;
    }
    .sheet {
      width: 100%;
      max-width: 800px;
      margin: 0 auto;
    }
    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 8px;
      border-bottom: 2px solid #4f46e5;
      margin-bottom: 12px;
    }
    .brand {
      display: flex;
      align-items: center;
      gap: 10px;
    }
    .brand-svg {
      width: 28px;
      height: 28px;
      flex-shrink: 0;
      display: inline-block;
      vertical-align: middle;
    }
    .brand-logo {
      font-size: 22px;
      font-weight: 900;
      color: #4f46e5;
      letter-spacing: -0.5px;
    }
    .brand-tag {
      font-size: 11px;
      font-weight: 700;
      color: #64748b;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      padding-left: 8px;
      border-left: 1px solid #cbd5e1;
    }
    .header-meta {
      text-align: right;
      font-size: 10px;
      color: #64748b;
    }
    .hero {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      gap: 16px;
      margin-bottom: 12px;
    }
    .title-block {
      flex: 1;
    }
    .property-title {
      font-size: 18px;
      font-weight: 900;
      color: #0f172a;
      margin: 0 0 4px 0;
      line-height: 1.25;
    }
    .property-subtitle {
      font-size: 11.5px;
      color: #475569;
      font-weight: 500;
    }
    .price-badge {
      background: #eef2ff;
      border: 1px solid #c7d2fe;
      border-radius: 8px;
      padding: 6px 12px;
      text-align: right;
      flex-shrink: 0;
    }
    .price-value {
      font-size: 18px;
      font-weight: 900;
      color: #3730a3;
      line-height: 1;
    }
    .price-sub {
      font-size: 9.5px;
      color: #6366f1;
      font-weight: 600;
      margin-top: 3px;
    }
    .photos-grid {
      display: grid;
      grid-template-columns: 2fr 1fr;
      gap: 8px;
      margin-bottom: 12px;
      border-radius: 8px;
      overflow: hidden;
    }
    .main-photo-container {
      height: 180px;
      background: #f1f5f9;
      border-radius: 6px;
      overflow: hidden;
    }
    .main-photo-container img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
    .secondary-photos {
      display: grid;
      grid-template-columns: 1fr;
      gap: 6px;
      height: 180px;
    }
    .secondary-photo {
      height: 100%;
      background: #f1f5f9;
      border-radius: 6px;
      overflow: hidden;
    }
    .secondary-photo img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
    .metrics-grid {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 6px;
      margin-bottom: 12px;
    }
    .metric-card {
      background: #f8fafc;
      border: 1px solid #e2e8f0;
      border-radius: 6px;
      padding: 6px 8px;
    }
    .metric-label {
      font-size: 9.5px;
      color: #64748b;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      display: block;
      margin-bottom: 2px;
    }
    .metric-value {
      font-size: 12.5px;
      color: #0f172a;
      font-weight: 800;
    }
    .section-title {
      font-size: 11px;
      font-weight: 800;
      color: #4f46e5;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      border-bottom: 1.5px solid #e2e8f0;
      padding-bottom: 3px;
      margin: 10px 0 6px 0;
      break-after: avoid;
    }
    .description-text {
      font-size: 11px;
      color: #334155;
      line-height: 1.5;
      margin-bottom: 12px;
      white-space: pre-line;
      break-inside: avoid;
    }
    .diagnostics-grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 10px;
      margin-bottom: 12px;
      break-inside: avoid;
    }
    .diag-card {
      background: #ffffff;
      border: 1px solid #e2e8f0;
      border-radius: 6px;
      padding: 8px 10px;
    }
    .diag-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 6px;
    }
    .diag-title {
      font-size: 10.5px;
      font-weight: 700;
      color: #1e293b;
    }
    .diag-metric {
      font-size: 10.5px;
      font-weight: 700;
      color: #475569;
    }
    .data-table {
      width: 100%;
      border-collapse: collapse;
      font-size: 10.5px;
      margin-bottom: 10px;
      break-inside: avoid;
    }
    .data-table th, .data-table td {
      padding: 4px 8px;
      border: 1px solid #e2e8f0;
      text-align: left;
    }
    .data-table th {
      background: #f8fafc;
      font-weight: 700;
      color: #475569;
    }
    .two-cols-section {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 10px;
      margin-bottom: 12px;
      break-inside: avoid;
    }
    .info-card {
      background: #f8fafc;
      border: 1px solid #e2e8f0;
      border-radius: 6px;
      padding: 8px 10px;
    }
    .info-row {
      display: flex;
      justify-content: space-between;
      padding: 3px 0;
      border-bottom: 1px dashed #e2e8f0;
      font-size: 10.5px;
    }
    .info-row:last-child {
      border-bottom: none;
    }
    .info-label {
      color: #64748b;
      font-weight: 500;
    }
    .info-val {
      color: #0f172a;
      font-weight: 700;
    }
    .map-container {
      border-radius: 8px;
      overflow: hidden;
      border: 1px solid #cbd5e1;
      height: 160px;
      background: #e2e8f0;
      margin-bottom: 8px;
      break-inside: avoid;
    }
    .map-container img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
    .pois-grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 5px;
      font-size: 10px;
      margin-bottom: 10px;
    }
    .poi-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 3.5px 6px;
      background: #ffffff;
      border: 1px solid #e2e8f0;
      border-radius: 4px;
    }
    /* Géorisques detailed styles */
    .geohazard-card {
      background: #ffffff;
      border: 1px solid #cbd5e1;
      border-radius: 8px;
      padding: 9px 11px;
      margin-bottom: 12px;
      break-inside: avoid;
    }
    .geohazard-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 6px;
      border-bottom: 1px solid #e2e8f0;
      margin-bottom: 8px;
    }
    .risk-badge-alert {
      background: #fef3c7;
      color: #92400e;
      border: 1px solid #fde68a;
      padding: 2px 7px;
      border-radius: 9999px;
      font-weight: 700;
      font-size: 9.5px;
    }
    .risk-badge-safe {
      background: #ecfdf5;
      color: #047857;
      border: 1px solid #a7f3d0;
      padding: 2px 7px;
      border-radius: 9999px;
      font-weight: 700;
      font-size: 9.5px;
    }
    .risk-tag-present {
      background: #fef3c7;
      color: #92400e;
      border: 1px solid #fcd34d;
      padding: 1px 5px;
      border-radius: 3px;
      font-weight: 700;
      font-size: 9px;
    }
    .risk-tag-none {
      color: #059669;
      font-size: 9px;
      font-weight: 600;
    }
    .geohazard-grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 10px;
      font-size: 10px;
    }
    .geohazard-subcol {
      background: #f8fafc;
      border: 1px solid #e2e8f0;
      border-radius: 6px;
      padding: 6px 8px;
    }
    .geohazard-subtitle {
      font-size: 9.5px;
      font-weight: 800;
      color: #334155;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      margin-bottom: 5px;
      padding-bottom: 3px;
      border-bottom: 1px solid #e2e8f0;
    }
    .risk-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 3px 0;
      border-bottom: 1px dashed #e2e8f0;
    }
    .risk-row:last-child {
      border-bottom: none;
    }
    .contact-box {
      background: #f5f3ff;
      border: 1.5px solid #a5b4fc;
      border-radius: 8px;
      padding: 8px 12px;
      margin-top: 10px;
      margin-bottom: 8px;
      break-inside: avoid;
    }
    .contact-title {
      font-size: 10.5px;
      font-weight: 800;
      color: #4338ca;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      margin: 0 0 4px 0;
    }
    .contact-details {
      display: flex;
      flex-wrap: wrap;
      gap: 14px;
      font-size: 11px;
      color: #1e293b;
    }
    .footer {
      border-top: 1px solid #e2e8f0;
      padding-top: 6px;
      font-size: 9px;
      color: #94a3b8;
      text-align: center;
      break-inside: avoid;
      margin-top: 10px;
    }
  </style>
</head>
<body>
  <div class="sheet">
    <!-- Header -->
    <div class="header">
      <div class="brand">
        ${ETXE_LOGO_SVG}
        <span class="brand-logo">ETXE</span>
        <span class="brand-tag">${isDetailed ? 'Dossier complet de présentation' : 'Fiche descriptive du bien'}</span>
      </div>
      <div class="header-meta">
        <div>Réf. : ${propertyReference}</div>
        <div>Éditée le ${today}</div>
      </div>
    </div>

    <!-- Hero Title & Price -->
    <div class="hero">
      <div class="title-block">
        <h1 class="property-title">${title}</h1>
        <div class="property-subtitle">
          ${propertyTypeStr}${subtypeStr ? ` (${subtypeStr})` : ''} • ${addressStr}
        </div>
      </div>
      <div class="price-badge">
        <div class="price-value">${priceStr}</div>
        <div class="price-sub">${pricePerM2 ? `${pricePerM2} • ` : ''}Net vendeur</div>
      </div>
    </div>

    <!-- Photos Grid -->
    ${
      mainPhotoUrl
        ? `
    <div class="photos-grid">
      <div class="main-photo-container">
        <img src="${mainPhotoUrl}" alt="Photo principale">
      </div>
      ${
        secondaryPhotos.length > 0
          ? `
      <div class="secondary-photos">
        ${secondaryPhotos
          .map(
            (sp) => `
        <div class="secondary-photo">
          <img src="${sp.url}" alt="Photo du bien">
        </div>`,
          )
          .join('')}
      </div>`
          : ''
      }
    </div>`
        : ''
    }

    <!-- Key Metrics Grid -->
    <div class="metrics-grid">
      ${
        surfaceHab
          ? `
      <div class="metric-card">
        <span class="metric-label">Surface habitable</span>
        <span class="metric-value">${surfaceHab} m²</span>
      </div>`
          : ''
      }
      ${
        totalCadastralSurface
          ? `
      <div class="metric-card">
        <span class="metric-label">Terrain / Parcelle</span>
        <span class="metric-value">${totalCadastralSurface} m²</span>
      </div>`
          : ''
      }
      ${
        roomCount
          ? `
      <div class="metric-card">
        <span class="metric-label">Nombre de pièces</span>
        <span class="metric-value">${roomCount} pièce${roomCount > 1 ? 's' : ''}</span>
      </div>`
          : ''
      }
      ${
        bedroomCount
          ? `
      <div class="metric-card">
        <span class="metric-label">Chambres</span>
        <span class="metric-value">${bedroomCount} chambre${bedroomCount > 1 ? 's' : ''}</span>
      </div>`
          : ''
      }
      ${
        bathroomCount
          ? `
      <div class="metric-card">
        <span class="metric-label">Salles d'eau / bain</span>
        <span class="metric-value">${bathroomCount}</span>
      </div>`
          : ''
      }
      ${
        surfaceGround
          ? `
      <div class="metric-card">
        <span class="metric-label">Surface au sol</span>
        <span class="metric-value">${surfaceGround} m²</span>
      </div>`
          : ''
      }
      ${
        wcCount
          ? `
      <div class="metric-card">
        <span class="metric-label">Toilettes (WC)</span>
        <span class="metric-value">${wcCount}</span>
      </div>`
          : ''
      }
      ${
        year
          ? `
      <div class="metric-card">
        <span class="metric-label">Période</span>
        <span class="metric-value">${year}</span>
      </div>`
          : ''
      }
      ${
        availability
          ? `
      <div class="metric-card">
        <span class="metric-label">Disponibilité</span>
        <span class="metric-value">${availability.isOccupied ? 'Occupé' : 'Libre'}${availability.saleUrgency ? `<br><span style="font-size: 9.5px; font-weight: 500; color: #64748b;">Vente : ${EtxeEnumsNiceLabelUtils.saleUrgency(availability.saleUrgency)}</span>` : ''}</span>
      </div>`
          : ''
      }
      ${
        parkings
          ? `
      <div class="metric-card">
        <span class="metric-label">Stationnement</span>
        <span class="metric-value">${parkings} place${parkings > 1 ? 's' : ''}</span>
      </div>`
          : ''
      }
    </div>

    <!-- Description -->
    ${
      description
        ? `
    <div class="section-title">Descriptif du bien</div>
    <div class="description-text">${description}</div>`
        : ''
    }

    <!-- DETAILED SECTIONS (IF DETAILED MODE) -->
    ${
      isDetailed && detailedRoomsList.length > 0
        ? `
    <div class="section-title">Composition et surfaces des pièces</div>
    <table class="data-table">
      <thead>
        <tr>
          <th>Désignation</th>
          <th style="width:120px;">Surface</th>
          <th>Précisions</th>
        </tr>
      </thead>
      <tbody>
        ${detailedRoomsList
          .map(
            (r) => `
        <tr>
          <td style="font-weight:700;">${r.name}</td>
          <td>${r.surface ? `${r.surface} m²` : '-'}</td>
          <td style="color:#64748b;font-style:italic;">${r.precision || '-'}</td>
        </tr>`,
          )
          .join('')}
      </tbody>
    </table>`
        : ''
    }

    ${
      isDetailed
        ? `
    <div class="two-cols-section">
      <div class="info-card">
        <div style="font-weight:800;font-size:10.5px;color:#1e293b;margin-bottom:5px;text-transform:uppercase;">Bâtiment & confort technique</div>
        ${heatingType ? `<div class="info-row"><span class="info-label">Chauffage</span><span class="info-val">${EtxeEnumsNiceLabelUtils.heatingType(heatingType as never)}${heatingEnergy ? ` (${EtxeEnumsNiceLabelUtils.heatingEnergy(heatingEnergy as never)})` : ''}</span></div>` : ''}
        ${hasAirConditioning != null ? `<div class="info-row"><span class="info-label">Climatisation</span><span class="info-val">${hasAirConditioning ? 'Oui' : 'Non'}</span></div>` : ''}
        ${ventilationType ? `<div class="info-row"><span class="info-label">Ventilation</span><span class="info-val">${ventilationType}</span></div>` : ''}
        ${glazing ? `<div class="info-row"><span class="info-label">Vitrage</span><span class="info-val">${glazing}</span></div>` : ''}
        ${wallsMaterial ? `<div class="info-row"><span class="info-label">Matériaux des murs</span><span class="info-val">${wallsMaterial}</span></div>` : ''}
        ${roofMaterial ? `<div class="info-row"><span class="info-label">Toiture</span><span class="info-val">${roofMaterial}</span></div>` : ''}
        ${condition ? `<div class="info-row"><span class="info-label">État général</span><span class="info-val">${condition}</span></div>` : ''}
        ${apartmentFloor != null ? `<div class="info-row"><span class="info-label">Étage</span><span class="info-val">${apartmentFloor === 0 ? 'Rez-de-chaussée' : `Étage ${apartmentFloor}`}${buildingNumberOfFloors ? ` sur ${buildingNumberOfFloors}` : ''}</span></div>` : ''}
        ${hasElevator != null ? `<div class="info-row"><span class="info-label">Ascenseur</span><span class="info-val">${hasElevator ? 'Oui' : 'Non'}</span></div>` : ''}
        ${pmrCompliance != null ? `<div class="info-row"><span class="info-label">Accès PMR</span><span class="info-val">${pmrCompliance ? 'Oui' : 'Non'}</span></div>` : ''}
      </div>

      <div class="info-card">
        <div style="font-weight:800;font-size:10.5px;color:#1e293b;margin-bottom:5px;text-transform:uppercase;">Copropriété, extérieur & finances</div>
        ${isInCoOwnership != null ? `<div class="info-row"><span class="info-label">Copropriété</span><span class="info-val">${isInCoOwnership ? `Oui${numberOfLots ? ` (${numberOfLots} lots)` : ''}` : 'Non'}</span></div>` : ''}
        ${lotNumber ? `<div class="info-row"><span class="info-label">Numéro de lot</span><span class="info-val">${lotNumber}</span></div>` : ''}
        ${trusteeName ? `<div class="info-row"><span class="info-label">Syndic</span><span class="info-val">${trusteeName}</span></div>` : ''}
        ${orientation ? `<div class="info-row"><span class="info-label">Orientation</span><span class="info-val">${orientation}</span></div>` : ''}
        ${gardenSurface > 0 ? `<div class="info-row"><span class="info-label">Jardin</span><span class="info-val">${gardenSurface} m²</span></div>` : ''}
        ${terraceSurface > 0 ? `<div class="info-row"><span class="info-label">Terrasse</span><span class="info-val">${terraceSurface} m²</span></div>` : ''}
        ${balconySurface > 0 ? `<div class="info-row"><span class="info-label">Balcon</span><span class="info-val">${balconySurface} m²</span></div>` : ''}
        ${hasPool ? `<div class="info-row"><span class="info-label">Piscine</span><span class="info-val">Oui</span></div>` : ''}
        ${propertyTax ? `<div class="info-row"><span class="info-label">Taxe foncière</span><span class="info-val">${propertyTax}</span></div>` : ''}
        ${coOwnershipCharges ? `<div class="info-row"><span class="info-label">Charges copro</span><span class="info-val">${coOwnershipCharges}</span></div>` : ''}
      </div>
    </div>

    <!-- Équipements & confort -->
    ${
      equipmentItems.length > 0
        ? `
    <div style="break-inside: avoid; margin-bottom: 12px;">
      <div class="section-title">Équipements & confort</div>
      <div style="display: flex; flex-wrap: wrap; gap: 6px;">
        ${equipmentItems
          .map(
            (eq) => `
        <span style="display: inline-block; background: #f8fafc; border: 1px solid #cbd5e1; border-radius: 6px; padding: 4px 8px; font-size: 10px; font-weight: 700; color: #1e293b;">
          ${eq.label}
        </span>`,
          )
          .join('')}
      </div>
    </div>`
        : ''
    }

    <!-- Conditions de mandat & attentes vendeur -->
    ${
      mandate &&
      (mandate.type ||
        mandate.duration ||
        mandate.targetCommissionRate ||
        mandatePriorities.length > 0 ||
        mandate.specialInstructions)
        ? `
    <div style="break-inside: avoid; margin-bottom: 12px;">
      <div class="section-title">Conditions de mandat & attentes vendeur</div>
      <div class="two-cols-section">
        <div class="info-card">
          <div style="font-weight:800;font-size:10.5px;color:#1e293b;margin-bottom:5px;text-transform:uppercase;">Modalités du mandat</div>
          ${mandate.type ? `<div class="info-row"><span class="info-label">Type de mandat</span><span class="info-val">${EtxeEnumsNiceLabelUtils.mandateType(mandate.type)}</span></div>` : ''}
          ${mandate.duration ? `<div class="info-row"><span class="info-label">Durée souhaitée</span><span class="info-val">${EtxeEnumsNiceLabelUtils.mandateDuration(mandate.duration)}</span></div>` : ''}
          ${mandate.targetCommissionRate ? `<div class="info-row"><span class="info-label">Honoraires ciblés</span><span class="info-val" style="color:#4f46e5;">${mandate.targetCommissionRate} % max</span></div>` : ''}
          ${mandateKeyManagement.length > 0 ? `<div class="info-row"><span class="info-label">Organisation des visites</span><span class="info-val">${mandateKeyManagement.join(', ')}</span></div>` : ''}
        </div>
        <div class="info-card">
          <div style="font-weight:800;font-size:10.5px;color:#1e293b;margin-bottom:5px;text-transform:uppercase;">Priorités & consignes</div>
          ${mandatePriorities.length > 0 ? `<div class="info-row"><span class="info-label">Priorités vendeur</span><span class="info-val">${mandatePriorities.join(', ')}</span></div>` : ''}
          ${mandate.specialInstructions ? `<div style="margin-top:5px; font-size:10px; color:#475569; font-style:italic;">« ${mandate.specialInstructions} »</div>` : ''}
        </div>
      </div>
    </div>`
        : ''
    }`
        : ''
    }

    <!-- Diagnostics DPE / GES -->
    <div class="diagnostics-grid">
      <div class="diag-card">
        <div class="diag-header">
          <span class="diag-title">Performance énergétique (DPE)</span>
          <span class="diag-metric">${dpeConsumption ? `${dpeConsumption} kWh/m²/an` : ''}</span>
        </div>
        ${dpeClass ? renderSpectrum(dpeClass, false) : '<div style="font-size:11px;color:#94a3b8;font-style:italic;">En cours ou non renseigné</div>'}
        ${
          dpeCostMin && dpeCostMax
            ? `<div style="font-size:9.5px;color:#64748b;margin-top:4px;">Coûts estimés : ${dpeCostMin} € à ${dpeCostMax} €/an</div>`
            : ''
        }
      </div>

      <div class="diag-card">
        <div class="diag-header">
          <span class="diag-title">Émissions de gaz (GES)</span>
          <span class="diag-metric">${gesEmissions ? `${gesEmissions} kg CO₂/m²/an` : ''}</span>
        </div>
        ${gesClass ? renderSpectrum(gesClass, true) : '<div style="font-size:11px;color:#94a3b8;font-style:italic;">En cours ou non renseigné</div>'}
        ${
          dpeDate || dpeAdeme
            ? `<div style="font-size:9.5px;color:#64748b;margin-top:4px;">${dpeDate ? `Réalisé le ${dpeDate}` : ''}${dpeAdeme ? ` • N° ADEME : ${dpeAdeme}` : ''}</div>`
            : ''
        }
      </div>
    </div>

    <!-- Localisation & commodités de quartier -->
    ${
      options.includeMapAndPois && (staticMapUrl || pois.length > 0)
        ? `
    <div style="break-inside: avoid; margin-bottom: 12px;">
      <div class="section-title">Localisation et commodités du quartier</div>
      ${
        staticMapUrl
          ? `
      <div class="map-container">
        <img src="${staticMapUrl}" alt="Plan de situation">
      </div>`
          : ''
      }
      ${
        pois.length > 0
          ? `
      <div style="font-size:10px;font-weight:700;color:#64748b;text-transform:uppercase;margin:5px 0 4px 0;">À proximité immédiate à pied :</div>
      <div class="pois-grid">
        ${pois
          .map(
            (p) => `
          <div class="poi-item">
            <span style="font-weight:600;color:#1e293b;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:240px;">
              📍 ${p.name} ${p.details ? `<small style="color:#64748b;">(${p.details})</small>` : ''}
            </span>
            <span style="font-weight:700;color:#4f46e5;white-space:nowrap;margin-left:6px;">
              ${PropertyPdfPrintUtils.getWalkMinutes(p.distanceMeters)} min <small style="color:#64748b;">(${p.distanceMeters} m)</small>
            </span>
          </div>`,
          )
          .join('')}
      </div>`
          : ''
      }
    </div>`
        : ''
    }

    <!-- Cadastre, urbanisme & cadre de vie -->
    ${
      isDetailed && options.includeGeospatial && (cadastral || noise || insee || sitadel)
        ? `
    <div class="two-cols-section">
      <div class="info-card">
        <div style="font-weight:800;font-size:10.5px;color:#1e293b;margin-bottom:5px;text-transform:uppercase;">Cadastre & urbanisme</div>
        ${primaryParcel?.section ? `<div class="info-row"><span class="info-label">Section cadastrale</span><span class="info-val">${primaryParcel.section}</span></div>` : ''}
        ${primaryParcel?.numero ? `<div class="info-row"><span class="info-label">Numéro de parcelle</span><span class="info-val">${primaryParcel.numero}</span></div>` : ''}
        ${totalCadastralSurface ? `<div class="info-row"><span class="info-label">Contenance cadastrale</span><span class="info-val">${totalCadastralSurface} m²</span></div>` : ''}
        ${groundFootprint ? `<div class="info-row"><span class="info-label">Emprise du bâti</span><span class="info-val">${groundFootprint} m²</span></div>` : ''}
        ${sitadel?.pressureLevel ? `<div class="info-row"><span class="info-label">Dynamique construction (SITADEL)</span><span class="info-val">${sitadel.pressureLevel === 'high' ? 'Forte' : sitadel.pressureLevel === 'moderate' ? 'Modérée' : 'Calme'}${sitadel.permitsCount ? ` (${sitadel.permitsCount} permis)` : ''}</span></div>` : ''}
      </div>

      <div class="info-card">
        <div style="font-weight:800;font-size:10.5px;color:#1e293b;margin-bottom:5px;text-transform:uppercase;">Acoustique & cadre de vie</div>
        ${
          noise?.category
            ? `<div class="info-row"><span class="info-label">Ambiance acoustique</span><span class="info-val">${noise.category === 'calm' ? 'Calme' : noise.category === 'moderate' ? 'Modéré' : 'Exposé'}${noise.levelDb ? ` (${noise.levelDb} dB)` : ''}</span></div>`
            : ''
        }
        ${
          noise?.mainSources && noise.mainSources.length > 0
            ? `<div class="info-row"><span class="info-label">Sources sonores</span><span class="info-val">${EtxeEnumsNiceLabelUtils.noiseSource(noise.mainSources)}</span></div>`
            : noise
              ? `<div class="info-row"><span class="info-label">Sources sonores</span><span class="info-val">Aucune nuisance majeure</span></div>`
              : ''
        }
        ${
          insee?.affluenceLevel
            ? `<div class="info-row"><span class="info-label">Profil de quartier (INSEE)</span><span class="info-val">${insee.affluenceLevel === 'very_affluent' ? 'Très aisé' : insee.affluenceLevel === 'affluent' ? 'Aisé' : 'Médian'}${insee.medianIncome ? ` (${insee.medianIncome.toLocaleString('fr-FR')} €/an)` : ''}</span></div>`
            : ''
        }
      </div>
    </div>`
        : ''
    }

    <!-- ÉTAT DES RISQUES NATURELS ET TECHNOLOGIQUES (GÉORISQUES COMPLET) -->
    ${
      options.includeGeospatial && geohazard
        ? `
    <div class="geohazard-card">
      <div class="geohazard-header">
        <div style="display:flex;align-items:center;gap:6px;">
          <span style="font-size:15px;">🛡️</span>
          <div>
            <div style="font-weight:800;font-size:11.5px;color:#1e293b;">État des risques naturels et technologiques (Géorisques)</div>
            <div style="font-size:9.5px;color:#64748b;">Exposition aux aléas recensés par l'État pour cette parcelle</div>
          </div>
        </div>
        <div>
          ${
            geohazardData.detectedCount === 0
              ? `<span class="risk-badge-safe">✓ Aucun risque majeur recensé</span>`
              : `<span class="risk-badge-alert">⚠️ ${geohazardData.detectedCount} aléa${geohazardData.detectedCount > 1 ? 's' : ''} identifié${geohazardData.detectedCount > 1 ? 's' : ''}</span>`
          }
        </div>
      </div>

      ${
        geohazardData.naturalRisks.length > 0 || geohazardData.technoRisks.length > 0
          ? `
      <div class="geohazard-grid">
        <!-- Risques naturels -->
        <div class="geohazard-subcol">
          <div class="geohazard-subtitle">Risques naturels (climat & sol)</div>
          ${geohazardData.naturalRisks
            .map(
              (r) => `
            <div class="risk-row">
              <span style="font-weight:${r.present ? '700' : '500'};color:${r.present ? '#1e293b' : '#475569'};">${r.libelle}</span>
              ${
                r.present
                  ? `<span class="risk-tag-present">Présent ${r.precision ? `(${r.precision})` : ''}</span>`
                  : `<span class="risk-tag-none">Non exposé</span>`
              }
            </div>`,
            )
            .join('')}
        </div>

        <!-- Risques technologiques -->
        <div class="geohazard-subcol">
          <div class="geohazard-subtitle">Risques technologiques & industriels</div>
          ${geohazardData.technoRisks
            .map(
              (r) => `
            <div class="risk-row">
              <span style="font-weight:${r.present ? '700' : '500'};color:${r.present ? '#1e293b' : '#475569'};">${r.libelle}</span>
              ${
                r.present
                  ? `<span class="risk-tag-present">Présent ${r.precision ? `(${r.precision})` : ''}</span>`
                  : `<span class="risk-tag-none">Non exposé</span>`
              }
            </div>`,
            )
            .join('')}
        </div>
      </div>`
          : `
      <div style="padding: 10px; font-size: 10.5px; color: #64748b; font-style: italic; text-align: center;">
        Informations administratives Géorisques consultables sur le portail officiel de l'État : georisques.gouv.fr
      </div>`
      }

      <div style="margin-top:6px;font-size:9px;color:#64748b;display:flex;justify-content:space-between;align-items:center;border-top:1px solid #f1f5f9;padding-top:5px;">
        <span>Données officielles issues de l'API publique Géorisques (Ministère de la Transition Écologique).</span>
        ${geohazardData.url ? `<span style="color:#4f46e5;font-weight:600;">Rapport officiel consultable en ligne</span>` : ''}
      </div>
    </div>`
        : isDetailed && options.includeGeospatial
          ? `
    <div style="background:#f8fafc; border:1px solid #e2e8f0; border-radius:6px; padding:8px 12px; margin-bottom:12px; display:flex; justify-content:space-between; align-items:center; font-size:10px;">
      <span style="font-weight:700; color:#334155;">État des risques naturels et technologiques</span>
      <span style="color:#64748b; font-style:italic;">Données Géorisques non disponibles pour ces coordonnées</span>
    </div>`
          : ''
    }

    <!-- Contact Info (if included) -->
    ${
      options.includeContactInfos
        ? `
    <div class="contact-box">
      <div class="contact-title">Contact & organisation des visites</div>
      <div class="contact-details">
        <div>
          <strong>${sellerName}</strong>
        </div>
        ${
          sellerPhone
            ? `
        <div>
          <span>📞 Téléphone :</span>
          <strong>${sellerPhone}</strong>
        </div>`
            : ''
        }
        ${
          sellerEmail
            ? `
        <div>
          <span>✉️ Email :</span>
          <strong>${sellerEmail}</strong>
        </div>`
            : ''
        }
      </div>
    </div>`
        : ''
    }

    <!-- Footer -->
    <div class="footer">
      ${isDetailed ? 'Dossier complet de présentation' : 'Fiche descriptive'} fournie à titre indicatif - Document non contractuel - Émis via la plateforme ETXE
    </div>
  </div>
</body>
</html>`;
  }

  static printPropertySheet(property: PropertyDto, options: PropertyPrintOptions): void {
    const html = this.generatePrintHtml(property, options);
    const propertyReference =
      property.definition?.reference?.trim() ||
      (property._id ? `#${property._id.toString().slice(-6).toUpperCase()}` : 'ANNONCE');
    const pdfTitle = `Détails du bien ${propertyReference} _ ETXE`;
    const previousTitle = document.title;
    document.title = pdfTitle;

    const iframe = document.createElement('iframe');
    iframe.style.position = 'fixed';
    iframe.style.top = '0';
    iframe.style.left = '0';
    iframe.style.width = '1000px';
    iframe.style.height = '1000px';
    iframe.style.opacity = '0';
    iframe.style.pointerEvents = 'none';
    iframe.style.zIndex = '-9999';
    iframe.style.border = 'none';

    document.body.appendChild(iframe);

    const doc = iframe.contentWindow?.document;
    if (!doc) {
      document.body.removeChild(iframe);
      document.title = previousTitle;
      return;
    }

    doc.open();
    doc.write(html);
    doc.title = pdfTitle;
    doc.close();

    const doPrint = () => {
      try {
        iframe.contentWindow?.focus();
        iframe.contentWindow?.print();
      } finally {
        setTimeout(() => {
          document.title = previousTitle;
          if (iframe.parentNode) {
            document.body.removeChild(iframe);
          }
        }, 2000);
      }
    };

    const images = Array.from(doc.images);
    if (images.length === 0) {
      setTimeout(doPrint, 350);
    } else {
      let loaded = 0;
      const onImageFinish = () => {
        loaded++;
        if (loaded >= images.length) {
          setTimeout(doPrint, 350);
        }
      };

      images.forEach((img) => {
        if (img.complete) {
          onImageFinish();
        } else {
          img.addEventListener('load', onImageFinish);
          img.addEventListener('error', onImageFinish);
        }
      });

      // Fallback timeout in case an image takes too long
      setTimeout(doPrint, 2500);
    }
  }
}
